import { selectCurrentEntitiesById } from 'ducks/entities/selectors'
import { createBasicSelector } from 'util/redux'

export const selectAccountsById = createBasicSelector(state =>
  selectCurrentEntitiesById(state, 'account')
)
